import { GlobalStyles } from '@mui/material';

import { styles } from './styles';

import type { FC, PropsWithChildren as GlobalStylesProviderProps } from 'react';

export const GlobalStylesProvider: FC<GlobalStylesProviderProps> = ({
  children,
}) => (
  <>
    <GlobalStyles styles={styles} />
    {children}
  </>
);
